import React from 'react';
import { useDispatch } from 'react-redux';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { ResetByAttemps } from '../../reduxToolkit/CompanyEmployees/CompanyEmployeesApi';
import ButtonAction from './ButtonAction';

const BtnResetByAttemps = ({ id }) => {
    const dispatch = useDispatch();

    const sendResetByAttemps = () => {
        dispatch(ResetByAttemps(id));
    };

    return (
        <ButtonAction
            id='btn_brba_reset_att'
            name='reset_by_attempts'
            className='btn-icon-accent-450'
            Icon={RestartAltIcon}
            disabled={false}
            splitName={false}
            onClick={()=>{
                sendResetByAttemps();
            }}
        />
    );
};

export default BtnResetByAttemps;
